<style>
	.line-box {
		display: flex; flex-direction: row; height: 60px; align-items: center;
		
	}
	.line-name {
		width: 130px; text-align: right; padding-right: 10px;
	}
	.line-tag-box {
		display: flex; flex-direction: row;  align-items: center;
	}
	.line-tag {
		width: 700px;  background-color: #f2dede; color: #b94a48; line-height: 20px; padding: 10px; border-radius: 3px;
	}
	
	.upload-box {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		margin-bottom: 10px;
		margin-top: 10px;
	}
	.upload-content {
		width: 720px;
	}
	.avatar-uploader .el-upload {
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 80px;
	    height: 80px;
	    line-height: 80px;
	    text-align: center;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
	  }
	  .avatar {
		border: 1px dashed #d9d9d9;
	    width: 80px;
	    height: 80px;
	    display: block;
		object-fit: cover;
		border-radius: 6px;
	  }
	  .upload-list {
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;
		gap: 10px;
	  }
	  .upload-card {
		position: relative;
		width: 80px;
		height: 80px;
	  }
	  .upload-remove {
		position: absolute;
		top: -8px;
		right: -8px;
		width: 20px;
		height: 20px;
		border: none;
		border-radius: 50%;
		background: #f56c6c;
		color: #fff;
		line-height: 20px;
		text-align: center;
		cursor: pointer;
		padding: 0;
		z-index: 2;
	  }
	  .upload-remove:hover {
		background: #dd3f3f;
	  }
</style>

<template>
	<div>
		<div class="line-box">
			<div class="line-name">模板名称：</div>
			<el-input style="width: 720px;" placeholder="模板一" v-model="form.style_name"></el-input>
		</div>
		<div class="line-box">
			<div class="line-name">排序：</div>
			<el-input type="number" style="width: 720px;" placeholder="从小到大排序" v-model="form.sorts"></el-input>
		</div>
		<div class="line-tag-box">
			<div class="line-name"></div>
			<div class="line-tag">提醒： 从小到大排序，最小0。</div>
		</div>
		<div class="upload-box">
			<div class="line-name">上传示例图：</div>
			<div class="upload-content">
				<div v-if="form.exam_img_url" class="upload-list">
					<div class="upload-card">
						<img :src="form.exam_img_fullurl" class="avatar">
						<button type="button" class="upload-remove" @click.stop.prevent="removeExampleImg">×</button>
					</div>
				</div>
				<el-upload class="avatar-uploader" :action="this.$http_url + '/Upload/UploadImage'" :headers="headers" :show-file-list="false"
					:on-success="UploadSuccess1"
					:before-upload="beforeUpload"
					:on-error="UploadError"
					v-else
				>
					<i class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</div>
		</div>
		<div class="line-tag-box">
			<div class="line-name"></div>
			<div class="line-tag">提醒： 显示在模板列表中，点击小图预览。</div>
		</div>
		<div style="width: 100%; margin-top: 20px;">
			<el-button style="width: 100%;" type="primary" @click="addProduct">{{ isEdit ? '确认编辑' : '确认添加' }}</el-button>
		</div>
	</div>
</template>

<script>
	const defaultForm = function(){
		return {
			style_name:'',
			sorts:'',
			game_type:'pl3',
			example_img_id:'',
			exam_img_url:'',
			exam_img_fullurl:'',
		};
	};

	export default {
		props:{
			isEdit:{
				type:Boolean,
				default:false
			},
			editData:{
				type:Object,
				default:null
			}
		},
		data(){
			return {
				form:defaultForm(),
				headers:{
					Authorization:''
				}
			}
		},
		watch:{
			isEdit(){
				this.initForm();
			},
			editData(){
				this.initForm();
			}
		},
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
			this.initForm();
		},
		methods: {
			initForm(){
				this.form = defaultForm();
				if(!this.isEdit || !this.editData){
					return;
				}
				const examImgUrl = this.editData.exam_img_url || '';
				this.form = Object.assign(defaultForm(), {
					id:this.editData.id,
					style_name:this.editData.style_name,
					sorts:this.editData.sorts,
					exam_img_url:this.getImagePath(examImgUrl),
					exam_img_fullurl:this.getImageFullUrl(examImgUrl),
				});
			},
			addProduct() {
				console.log("add product", this.form);
				// 验证格式
				if(this.form.style_name == ""){
					return this.$message({ message: '请填写模板名称', type: 'warning' });
				}
				if(this.form.sorts == ""){
					return this.$message({ message: '请填写排序数值', type: 'warning' });
				}
				// 提交上传
				this.submit();
			},
			submit(){
				let _this = this;
				const url = this.isEdit ? "/TplSet/editStyle" : "/TplSet/TplStyleAdd";
				const loading = this.$loading({
						lock: true,
						text: this.isEdit ? '编辑中' : '添加中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post(url, this.form).then(res=>{
					loading.close();
					if(res.code == 1)
					{
						_this.$message({
							 message: this.isEdit ? '编辑成功~' : '添加成功~',
							 type: 'success',
						});
						_this.$emit('success');
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			beforeUpload(file){
			},
			UploadSuccess1(res, file, fileList){
				if(res.code == 200)
				{
					this.form.exam_img_url = res.file_path;
					this.form.exam_img_fullurl = this.$http_host + res.file_path;
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			removeExampleImg(){
				this.form.exam_img_url = '';
				this.form.exam_img_fullurl = '';
				this.form.example_img_id = '';
			},
			getImagePath(url){
				if(!url){
					return '';
				}
				if(this.$http_host && url.indexOf(this.$http_host) === 0){
					return url.replace(this.$http_host, '');
				}
				return url;
			},
			getImageFullUrl(url){
				if(!url){
					return '';
				}
				if(/^https?:\/\//.test(url)){
					return url;
				}
				return this.$http_host + url;
			},
			UploadError(){
				return this.$message({ message: '上传失败，请重试', type: 'warning' });
			}
		},
	}
</script>
